import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { LauncherModuleWithTrial } from '@layout/launcher/models/module.interface';
import { InstancePickerDialogComponent } from '@layout/instance-picker-dialog/components/instance-picker-dialog.component';
import { TranslatePipe } from '@ngx-translate/core';
import { NgOptimizedImage } from '@angular/common';
import { DialogService, TagComponent, TooltipDirective } from '@kaseya-design-components';
import { LauncherModulesFacade } from '@layout/launcher/facades/launcher-modules.facade';
import { ModuleInstancePickerDialogData } from '@layout/instance-picker-dialog/models/module-instance-picker-dialog-data.interface';

@Component({
  selector: 'itc-launcher-item',
  templateUrl: 'launcher-item.component.html',
  styleUrl: 'launcher-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TooltipDirective, TranslatePipe, NgOptimizedImage, TagComponent],
})
export class LauncherItemComponent {
  private readonly dialogService = inject(DialogService);
  private readonly launcherModulesFacade = inject(LauncherModulesFacade);

  readonly module = input.required<LauncherModuleWithTrial>();
  readonly isTooltipRightAligned = input(false);
  readonly isMultipleTenants = computed(() => this.module().instances.length > 1);

  openModule(): void {
    if (this.isMultipleTenants()) {
      this.openTenantPickerDialog();
      return;
    }

    this.openModuleLandingPage();
  }

  isFullTextDisplayed(element: HTMLSpanElement): boolean {
    return element.clientHeight >= element.scrollHeight;
  }

  private openTenantPickerDialog(): void {
    this.dialogService.openDialog<ModuleInstancePickerDialogData>(InstancePickerDialogComponent, {
      data: {
        moduleId: this.module().moduleId,
        moduleInstances: this.module().instances.map(({ name, landingPageUrl }) => ({ name, url: landingPageUrl })),
      },
      dismissOnBackdropClick: true,
    });
  }

  private openModuleLandingPage(): void {
    window.open(this.module().instances[0].landingPageUrl);
    this.launcherModulesFacade.hideLauncher();
  }
}
